import styles from "./LoadingSkeleton.module.css"

interface LoadingSkeletonProps {
    rows: number
    cells: number
}

export default function LoadingSkeleton({ rows = 8, cells = 4 }: LoadingSkeletonProps) {
    return (
        <div className={styles.wrapper}>
            {Array.from({ length: rows }).map((_, i) => (
                <div key={i} className={styles.row}>
                    {Array.from({ length: cells }).map((_, i) => (
                        <div key={i} className={`${styles.cell}`} />
                    ))}
                </div>
            ))}
        </div>
    )
}